import { Controller } from "@hotwired/stimulus"
import {debounce} from "../libs/utils";

/**
 * Add pagination[page] and pagination[count] param to a given form on click
 *
 * @example
 * <button data-controller="pagination-button"> Next </button>
 */

export default class PaginationButtonController extends Controller {
  static values = {
    formId: String,
    page: Number,
    count: Number,
    appendRecords: {type: Boolean, default: false}
  }

  initialize() {
    if (this.form == null) {
      console.error("PaginationButtonController: form not found");
      console.error("PaginationButtonController: here", this.element);
    }
  }

  get form() {
    return document.querySelector("#" + this.formIdValue);
  }

  submit() {
    if (this.form == null) {
      return;
    }

    const page = this.findOrCreateInputByName('pagination[page]');
    page.value = this.pageValue;


    const count = this.findOrCreateInputByName('pagination[count]');
    count.value = this.countValue;

    const appendRecords = this.findOrCreateInputByName('append_records');
    appendRecords.value = this.appendRecordsValue;

    this.form.insertAdjacentElement('beforeend', appendRecords);
    this.form.insertAdjacentElement('beforeend', page);
    this.form.insertAdjacentElement('beforeend', count);

    console.log("sort", this.form);
    this.element.setAttribute('disabled', 'disabled');

    this.form.requestSubmit();
  }

  findOrCreateInputByName(name) {
    let input = this.form.querySelector(`input[name="${name}"]`);

    if (input == null) {
      input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', name);
      this.form.insertAdjacentElement('beforeend', input);
    }

    return input;
  }
}
